import React from 'react';
import { useStringsContext } from '../../../../../contexts/strings';
import DeleteIcon from '@mui/icons-material/Delete';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { useSnackbar } from 'notistack';
import { collection, doc, deleteDoc } from 'firebase/firestore';
import firebaseApp from '../../../../../firebase-app';
import { FS_PATH_STORIES } from '../../../../../constants';
import { Story } from '../../types';
import BaseDialog from '../../../../common/base-dialog';

interface Props {
  open: boolean;
  selectedStory: Story;
  onDone: () => void;
  onClose: () => void;
}

const StoryDeleteModal = ({ open, selectedStory, onDone, onClose }: Props) => {
  const { strings } = useStringsContext();
  const [isLoading, setIsLoading] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const onDelete = async () => {
    setIsLoading(true);

    try {
      const colRef = collection(firebaseApp.db, FS_PATH_STORIES);
      const docRef = doc(colRef, selectedStory.id);
      await deleteDoc(docRef);

      enqueueSnackbar(strings.messages.deleteSuccess, {
        variant: 'success',
      });
      onDone();
    } catch (error) {
      console.error(error);
      enqueueSnackbar(strings.messages.deleteError, {
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BaseDialog
      open={open}
      title={strings.stories.deleteStoryTitle.replace('$name', selectedStory.caption)}
      onClose={onClose}
    >
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {strings.actions.cancel}
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isLoading}
          startIcon={<DeleteIcon />}
          onClick={onDelete}
        >
          {strings.actions.delete}
        </LoadingButton>
      </DialogActions>
    </BaseDialog>
  );
};

export default StoryDeleteModal;
